var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"m-badge m-badge-status"},[(_vm.avatarUrl)?_c('span',{staticClass:"m-avatar m-avatar-span",style:(_vm.avatarStyle)},[_c('img',{attrs:{"src":_vm.avatarUrl,"alt":""}})]):_c('span',{staticClass:"m-avatar m-avatar-icon",style:(_vm.avatarStyle)},[_c('span',{staticClass:"m-avatar-string"},[_vm._v(_vm._s(_vm.name[0]))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7421711f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/im/AccountAvatar.vue
// module id = null
// module chunks = 